import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import { HiOutlineMenu } from "react-icons/hi";
import { useLocation } from "react-router-dom";

import Sidebar from "./Menu";

import "../assets/scss/header.scss";

function Header(props) {
  const { onAction } = props;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const onFilter = (value) => {
    if (onAction) {
      onAction(value);
    }
  };


  return (
    <>

      <div className={"header-container"}>
        <Navbar expand="lg" className="bg-body-tertiary ">
          <Container className={"flex-nowrap m-0 mt-1"}>
            <HiOutlineMenu
              onClick={() => setSidebarOpen(true)}
              style={{ cursor: "pointer" }}
              size={24}
            />
            {location.pathname === "/bang-ke" ? <Navbar.Brand className="fw-bold ms-2 me-4">BẢNG KÊ CHI PHÍ</Navbar.Brand> :
              <Navbar.Brand className="fw-bold ms-2 me-4">TRA CỨU VẬN CHUYỂN</Navbar.Brand>}

            <Nav className="me-auto flex-nowrap flex-row ">
              {location.pathname !== "/bang-ke" ? <Nav.Link
                className="text-primary"
                href="#"
                onClick={() => onFilter("yesterday")}
              >
                Hôm qua
              </Nav.Link> : ''}
              {location.pathname !== "/bang-ke" ? <Nav.Link
                className="text-primary"
                href="#"
                onClick={() => onFilter("today")}
              >
                Hôm nay
              </Nav.Link> : ''}
              {location.pathname !== "/bang-ke" ? <Nav.Link
                className="text-primary"
                href="#"
                onClick={() => onFilter("tomorrow")}
              >
                Ngày mai
              </Nav.Link> : ''}
              <Nav.Link
                className="text-primary"
                href="#"
                onClick={() => onFilter("thismonth")}
              >
                Tháng này
              </Nav.Link>
              <Nav.Link
                className="text-primary"
                href="#"
                onClick={() => onFilter("lastmonth")}
              >
                Tháng trước
              </Nav.Link>
            </Nav>

          </Container>
        </Navbar>
      </div>


      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
    </>
  );
}

export default Header;
